import styled from 'styled-components';
import { Text14Light, Text14Regular } from '../../Text/Text.styles';
import { theme } from '../../../../styles/constants';

export const StyledLabel = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 1.8rem;
  opacity: ${props => (props.disabled ? 0.8 : 1)};
`;

export const StyledInput = styled.input`
  font-size: 1.5rem;
  letter-spacing: -0.15px;
  line-height: normal;
  font-weight: 400;
  color: ${theme.colors.textColor};
  background: ${theme.colors.white};
  height: 4.8rem;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #97c9f1;
  padding: 1.4rem 1.6rem;
  padding-right: ${props => (props.type === 'password' || props.$isShown || props.$rightIcon ? '5rem' : '0')};
  padding-left: ${props => (props.$leftIcon ? '3.2rem' : '1.2rem')};
  box-shadow: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'auto')};

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
  }

  &::placeholder {
    color: #0b3a5f;
    font-weight: 300;
  }
`;

export const StyledTextarea = styled.textarea`
  font-size: 1.5rem;
  line-height: normal;
  font-weight: 400;
  color: ${theme.colors.textColor};
  background: ${theme.colors.white};
  height: ${({ $textAreaHeight }) => ($textAreaHeight ? `${$textAreaHeight / 10}rem` : '14rem')};
  width: 100%;
  border: 1px solid #97c9f1;
  border-radius: 12px;
  padding: 1.4rem 1.6rem;
  box-shadow: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'auto')};
  resize: none;

  &::placeholder {
    color: #0b3a5f;
    font-weight: 300;
  }
`;

export const VisibilityButton = styled.div`
  position: absolute;
  border: none;
  cursor: pointer;
  background: transparent;
  top: ${props => (props.$labelExists ? '3.6rem' : '1.2rem')};
  right: 16px;
  height: 2.4rem;

  > svg {
    fill: #97c9f1;
  }
`;

export const LeftIconContainer = styled.div`
  position: absolute;
  height: 2.4rem;
  top: ${props => (props.$labelExists ? '4.8rem' : '1.4rem')};
  left: 1.4rem;

  font-size: 1.6rem;
`;

export const RightIconContainer = styled.div`
  position: absolute;
  min-height: 2.4rem;
  min-width: 2.4rem;
  top: ${props =>
    props.$labelExists ? (props.$rightIconLoader ? '2.4rem' : '3.6rem') : props.$rightIconLoader ? '0.2rem' : '1.2rem'};
  right: ${props => (!props.$rightIconLoader ? '1rem' : '0')};
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const Loader = styled.img`
  width: 4.8rem;
`;

export const LabelText = styled(Text14Regular)`
  text-transform: capitalize;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: relative;
  width: fit-content;
  margin-bottom: 0.6rem;
  margin-left: 0.2rem;
`;

export const TooltipContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #badaf7;
  background: #fff;
  padding: 1.2rem;
  position: absolute;
  width: 24rem;
  right: 0;
  bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  z-index: 1000;
`;

export const TooltipText = styled(Text14Light)`
  opacity: 0.8;
  line-height: 20px;
  letter-spacing: -0.408px;
`;
